import { render, staticRenderFns } from "./CoverImg.vue?vue&type=template&id=4cbebb59"
import script from "./CoverImg.vue?vue&type=script&lang=js"
export * from "./CoverImg.vue?vue&type=script&lang=js"
import style0 from "./CoverImg.vue?vue&type=style&index=0&id=4cbebb59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports